module.exports = __webpack_public_path__ + "static/img/16.371e796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/16.jpg
// module id = PEWD
// module chunks = 0